export default {
    topics: [
        {
            title: 'Standards',
            href: 'control-Button.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e7866',
            next: 'tocId-d66e7866',
        },
        {
            title: 'Statics',
            href: 'control-Help.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e8036',
            next: 'tocId-d66e8036',
        },
        {
            title: 'Advanced',
            href: 'control-DiagramEdit.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e8061',
            next: 'tocId-d66e8061',
        },
        {
            title: 'Containers',
            href: 'control-HPaned.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e8086',
            next: 'tocId-d66e8086',
        },
    ],
};

